import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { AuthContext } from "../../context/AuthContext";
import JobItem from "../../component/JobItem";
import { generateRandomString } from "../../Utility/Utility";
import moment from "moment";
import { useSnackbar } from "notistack";
import EmailApplyModal from "./EmailApplyModal";

export default function jobsDetails(props) {
  const [jobsDetail, setJobsDetail] = useState([]);
  const [jobSkills, setJobSkills] = useState([]);
  const [sameCompanyJobs, setSameCompanyJobs] = useState([]);
  const [similarjobs, setSimilarJobs] = useState([]);
  const [hasApplied, setHasApplied] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);
  // const id = props.match.params.id;
  const slug = props.match.params.slug;
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  useEffect(() => {
    
    let isMounted = true;
    const controller = new AbortController();
    
    window.scrollTo(0, 0);
    
    axios.post("api/get_jobs_detail", { slug: slug }, { signal: controller.signal }).then((res) => {
      if (!isMounted) return;
      if (res.data.status == "success") {
        setJobsDetail(res.data.data[0]);
        setJobSkills(res.data.data[0].jobskills);
        setSameCompanyJobs(res.data.samecompanyjobs);
        setSimilarJobs(res.data.similarjobs);
        setHasApplied(res.data.hasApplied);
        setHasSaved(res.data.hasSaved);
      } else {
        setJobsDetail([]);
        setJobSkills([]);
        setSameCompanyJobs([]);
        setSimilarJobs([]);
      }
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError" && error.name !== "CanceledError") {
        console.error("Failed to load job details:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [slug]);

  const handleJobApply = () => {
    axios.post("api/seeker/apply_job", { id: jobsDetail.id }).then((resp) => {
      if (resp.data.status == "success") {
        setHasApplied(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setHasApplied(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    });
  };

  const handleJobSave = () => {
    axios.post("api/seeker/save_job", { id: jobsDetail.id }).then((resp) => {
      if (resp.data.status == "success") {
        setHasSaved(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setHasSaved(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    });
  };

  const handleFacebookShare = () => {
    const url = window.location.href;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(facebookShareUrl, "_blank");
  };

  const handleTwitterShare = () => {
    const url = window.location.href;
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
    window.open(twitterShareUrl, "_blank");
  };

  const handleLinkedInShare = () => {
    const url = window.location.href;
    const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    window.open(linkedInShareUrl, "_blank");
  };

  return (
    <div className="section-full p-t120  p-b60 site-bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="cabdidate-de-info">
              <div className="twm-job-self-wrap">
                <div className="twm-job-self-info">
                  <div className="twm-job-self-top">
                    <div className="twm-media-bg">
                      <img
                        src={jobsDetail.jobcoverimgUrl}
                        alt={jobsDetail.job_title}
                      />

                      {jobsDetail.work_type != null ? (
                        <div className="twm-jobs-category">
                          <span className="twm-bg-purple">
                            {jobsDetail.work_type}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {jobsDetail.imgUrl != null ? (
                      <div className="twm-media">
                        <img
                          src={jobsDetail.imgUrl}
                          alt={jobsDetail.job_title}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="company_name_dtl">
                      <Link to={`/company/${jobsDetail.clientslug}`}>
                        {jobsDetail.comp_name}
                      </Link>
                    </div>

                    <div className="twm-mid-content">
                      {jobsDetail.job_title != "" ? (
                        <h4 className="twm-job-title">
                          {jobsDetail.job_title}
                          <span className="twm-job-post-duration">
                            / {moment(jobsDetail.created_at).fromNow()}
                          </span>
                        </h4>
                      ) : (
                        ""
                      )}
                      {jobsDetail.no_of_vacancy != "" ? (
                        <p className="twm-job-address">
                          No. of Vacancy:
                          {jobsDetail.no_of_vacancy}
                        </p>
                      ) : (
                        ""
                      )}
                      {jobsDetail.job_location != "" ? (
                        <p className="twm-job-address">
                          <i className="ri-map-pin-line"></i>{" "}
                          {jobsDetail.job_location}
                        </p>
                      ) : (
                        ""
                      )}
                      <div className="twm-job-self-mid">
                        <div className="twm-job-self-mid-left">
                          {/* {jobsDetail.min_exp != "" ? (
                            <span className="twm-jobs-type site-text-primary">
                              <i className="ri-briefcase-line"></i>{" "}
                              {jobsDetail.min_exp}-{jobsDetail.max_exp} Year
                            </span>
                          ) : (
                            ""
                          )} */}
                          {jobsDetail.experience_type == "N" ? (
                            <span className="twm-jobs-type site-text-primary">
                              <i className="ri-briefcase-line"></i>No Experience
                            </span>
                          ) : jobsDetail.experience_type == "F" ? (
                            <span className="twm-jobs-type site-text-primary">
                              <i className="ri-briefcase-line"></i>Fresher
                            </span>
                          ) : jobsDetail.experience_type == "E" ? (
                            <span className="twm-jobs-type site-text-primary">
                              <i className="ri-briefcase-line"></i>
                              {jobsDetail.min_exp} 
                              {jobsDetail.min_exp_unit === jobsDetail.exp_unit 
                                ?  `- ${jobsDetail.max_exp}${jobsDetail.exp_unit}`
                                : ` ${jobsDetail.min_exp_unit ? jobsDetail.min_exp_unit : ""} - ${jobsDetail.max_exp} ${jobsDetail.exp_unit}`
                              }
                            </span>
                          ) : (
                            ""
                          )}
                          {jobsDetail.joblevel != null ? (
                            <span className="twm-job-websites site-text-primary">
                              <i className="ri-building-line"></i>{" "}
                              {jobsDetail.joblevel}
                            </span>
                          ) : (
                            ""
                          )}
                          {jobsDetail.job_type != null ? (
                            <span className="twm-job-websites site-text-primary">
                              <i className="ri-building-line"></i>{" "}
                              {jobsDetail.job_type}
                            </span>
                          ) : (
                            ""
                          )}
                          {jobsDetail.gender != null ? (
                            <span className="twm-job-websites site-text-primary">
                              <i className="ri-genderless-line"></i>{" "}
                              {jobsDetail.gender}
                            </span>
                          ) : (
                            ""
                          )}
                          {jobsDetail.driving_license == "Y" ? (
                            <span className="twm-job-websites site-text-primary">
                              <i className="ri-sim-card-2-fill"></i> Driving
                              License: Yes
                            </span>
                          ) : jobsDetail.driving_license == "N" ? (
                            <span className="twm-job-websites site-text-primary">
                              <i className="ri-sim-card-2-fill"></i> Driving
                              License: No
                            </span>
                          ) : (
                            ""
                          )}
                          {jobsDetail.salary_type == "R" ? (
                            <span className="twm-jobs-amount  site-text-primary">
                              <i className="ri-money-dollar-circle-line"></i>{" "}
                              {jobsDetail.jobcur} {jobsDetail.minsalary}-
                              {jobsDetail.maxsalary} / {jobsDetail.salary_unit}
                            </span>
                          ) : jobsDetail.salary_type == "F" ? (
                            <span className="twm-jobs-amount  site-text-primary">
                              <i className="ri-money-dollar-circle-line"></i>{" "}
                              {jobsDetail.jobcur} {jobsDetail.minsalary}/{" "}
                              {jobsDetail.salary_unit}
                            </span>
                          ) : jobsDetail.salary_type == "N" ? (
                            <span className="twm-jobs-amount  site-text-primary">
                              {" "}
                              <i className="ri-money-dollar-circle-line"></i>{" "}
                              Negotiable
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="twm-job-apllication-area">
                          {jobsDetail.educationlevel != "" ? (
                            <div>
                              {" "}
                              Education Level :
                              <span className="twm-job-websites site-text-primary">
                                {jobsDetail.educationlevel}
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                          {jobsDetail.degreename != "" ? (
                            <div>
                              {" "}
                              Degree :
                              <span className="twm-job-websites site-text-primary">
                                {jobsDetail.degreename}
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {jobSkills.length > 0 && <div>Skills :</div>}
                        <p>
                          {jobSkills.length > 0
                            ? jobSkills.map((skillitem, idx) => (
                                <span className="badge badge-secondary">
                                  {skillitem.title}
                                </span>
                              ))
                            : ""}
                        </p>

                        <div className="twm-job-apllication-area">
                          Application ends:
                          <span className="twm-job-apllication-date">
                            {jobsDetail.apply_before}
                          </span>
                        </div>
                      </div>

                      {!isAuthenticated ? (
                        <div className="job-save-btn">
                          <Link to="/login" className="btn btn-outline-info">
                            <i className="ri ri-save-line"></i> Save Job
                          </Link>
                        </div>
                      ) : null}

                      {!isAuthenticated && jobsDetail.apply_direct== 'Y' && jobsDetail.daysDifference >= 0 ? (
                        <div className="job-email-apply-btn">
                          <Link
                            to="#easy_apply_popup"
                            className="btn btn-outline-primary"
                            data-bs-toggle="modal"
                          >
                            <i className="ri ri-mail-line"></i> Email Apply
                          </Link>
                        </div>
                      ) : !isAuthenticated && jobsDetail.daysDifference < 0 ? (
                        <div className="job-email-apply-btn">
                          <button className="btn btn-danger">Expired</button>
                        </div>
                      ) : null}
                      {isAuthenticated &&
                      userType == "seeker" &&
                      jobsDetail.apply_direct== 'Y' &&
                      jobsDetail.daysDifference >= 0 ? (
                        <div className="job-email-apply-btn">
                          <Link
                            to="#easy_apply_popup"
                            className="btn btn-outline-primary"
                            data-bs-toggle="modal"
                          >
                            <i className="ri ri-mail-line"></i> Email Apply
                          </Link>
                        </div>
                      ) : isAuthenticated &&
                        userType == "seeker" &&
                        jobsDetail.daysDifference < 0 ? (
                        <div className="job-email-apply-btn">
                          <button className="btn btn-danger">Expired</button>
                        </div>
                      ) : null}

                      {isAuthenticated && userType == "seeker" ? (
                        hasSaved ? (
                          <div className="job-save-btn">
                            <Link
                              to="/profile?tab=savedJobs"
                              className="btn btn-outline-info"
                            >
                              <i className="ri ri-save-line"></i> Already Saved
                            </Link>
                          </div>
                        ) : (
                          <div className="job-save-btn">
                            <a
                              href="javascript:;"
                              onClick={handleJobSave}
                              className="btn btn-outline-info"
                            >
                              <i className="ri ri-save-line"></i> Save Job
                            </a>
                          </div>
                        )
                      ) : null}

                      {!isAuthenticated && jobsDetail.apply_online == 'Y' && jobsDetail.daysDifference >= 0 ? (
                        <div className="twm-job-self-bottom">
                          <Link to="/login" className="site-button">
                            <i className="ri ri-send-plane-line"></i> Apply Now
                          </Link>
                        </div>
                      ) : null}
                      {isAuthenticated &&
                      userType == "seeker" &&
                      jobsDetail.apply_online == 'Y' &&
                      jobsDetail.daysDifference >= 0 ? (
                        hasApplied ? (
                          <div className="twm-job-self-bottom">
                            <Link
                              to="/profile?tab=appliedJobs"
                              className="btn btn-outline-success"
                            >
                              <i className="ri ri-send-plane-line"></i> Already
                              Applied
                            </Link>
                          </div>
                        ) : (
                          <div className="twm-job-self-bottom">
                            <a
                              href="javascript:;"
                              onClick={handleJobApply}
                              className="site-button"
                            >
                              <i className="ri ri-send-plane-line"></i> Apply Now
                            </a>
                          </div>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {jobsDetail.job_description != null ? (
                <div>
                  <h4 className="twm-s-title">Job Description</h4>

                  {ReactHtmlParser(jobsDetail.job_description)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.job_specification != null ? (
                <div>
                  <h4 className="twm-s-title">Job Specification</h4>
                  {ReactHtmlParser(jobsDetail.job_specification)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.education_required != null ? (
                <div>
                  <h4 className="twm-s-title">
                    Required Knowledge, Skills, and Abilities
                  </h4>
                  {ReactHtmlParser(jobsDetail.education_required)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.job_benefit != null ? (
                <div>
                  <h4 className="twm-s-title">Benefits</h4>
                  {ReactHtmlParser(jobsDetail.job_benefit)}
                </div>
              ) : (
                ""
              )}
              {jobsDetail.instruction != null ? (
                <div>
                  <h4 className="twm-s-title">Apply Instruction</h4>
                  {ReactHtmlParser(jobsDetail.instruction)}
                </div>
              ) : (
                ""
              )}

              {/* <div className="widget tw-sidebar-tags-wrap">
                <h4 className="twm-s-title">Jobs Skills:</h4>
                <div className="tagcloud">
                  <a href="javascript:void(0)">HTML</a>
                  <a href="javascript:void(0)">CSS</a>
                  <a href="javascript:void(0)">JavaScript</a>
                  <a href="javascript:void(0)">Photoshop</a>
                  <a href="javascript:void(0)">Bootstrap</a>
                  <a href="javascript:void(0)">WordPress</a>
                  <a href="javascript:void(0)">Figma</a>
                  <a href="javascript:void(0)">Reactjs</a>
                </div>
              </div> */}

              {!isAuthenticated && jobsDetail.apply_online == 'Y' && jobsDetail.daysDifference >= 0 ? (
                <div className="twm-job-self-bottom">
                  <Link to="/login" className="site-button">
                    Apply Now
                  </Link>
                </div>
              ) : null}
              {isAuthenticated &&
              userType == "seeker" &&
              jobsDetail.apply_online == 'Y' &&
              jobsDetail.daysDifference >= 0 ? (
                hasApplied ? (
                  <div className="twm-job-self-bottom">
                    <Link
                      to="/profile?tab=appliedJobs"
                      className="btn btn-outline-success"
                    >
                      Already Applied
                    </Link>
                  </div>
                ) : (
                  <div className="twm-job-self-bottom">
                    <a
                      href="javascript:;"
                      onClick={handleJobApply}
                      className="site-button"
                    >
                      Apply Now
                    </a>
                  </div>
                )
              ) : null}

              <h4 className="twm-s-title">Share Jobs</h4>
              <div className="twm-social-tags">
                <a
                  href="javascript:void(0)"
                  className="fb-clr"
                  id="facebook-share-button"
                  onClick={handleFacebookShare}
                >
                  Facebook
                </a>
                <a
                  href="javascript:void(0)"
                  className="tw-clr"
                  id="twitter-share-button"
                  onClick={handleTwitterShare}
                >
                  Twitter
                </a>
                <a
                  href="javascript:void(0)"
                  className="link-clr"
                  id="linkedin-share-button"
                  onClick={handleLinkedInShare}
                >
                  Linkedin
                </a>
              </div>

              {/* <h4 className="twm-s-title">Location</h4>
              <div className="twm-m-map mb-5">
                <div className="twm-m-map-iframe">
                  <iframe
                    height="310"
                    src="https://maps.google.com/maps?q=DishHome%20FiberNet%20bagbazar&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  ></iframe>
                </div>
              </div> */}

              {sameCompanyJobs.length > 0 ? (
                <div>
                  <h4 className="twm-s-title">Other Jobs By This Company</h4>

                  <div className="twm-jobs-list-wrap">
                    <ul>
                      {sameCompanyJobs.length > 0
                        ? sameCompanyJobs.map((scj) => (
                            <li>
                              <div className="twm-jobs-list-style1 mb-2">
                                <div className="twm-media">
                                  <img src={scj.imgUrl} alt={scj.job_title} />
                                </div>
                                <div className="twm-mid-content">
                                  <Link
                                    to={`/jobs/${scj.slug}`}
                                    className="twm-job-title"
                                  >
                                    <h4 className="twm-job-title">
                                      {scj.job_title}{" "}
                                      <span className="twm-job-post-duration">
                                        / {moment(scj.created_at).fromNow()}
                                      </span>
                                    </h4>
                                  </Link>
                                  {scj.job_location != "" ? (
                                    <p className="twm-job-address">
                                      {scj.job_location}
                                    </p>
                                  ) : (
                                    ""
                                  )}

                                  {scj.experience_type == "N" ? (
                                    <span className="twm-jobs-type site-text-primary">
                                      <i className="ri-briefcase-line"></i>No
                                      Experience
                                    </span>
                                  ) : scj.experience_type == "F" ? (
                                    <span className="twm-jobs-type site-text-primary">
                                      <i className="ri-briefcase-line"></i>
                                      Fresher
                                    </span>
                                  ) : scj.experience_type == "E" ? (
                                    <span className="twm-jobs-type site-text-primary">
                                      <i className="ri-briefcase-line"></i>
                                      {scj.min_exp} 
                                      {scj.min_exp_unit === scj.exp_unit 
                                        ?  `- ${scj.max_exp}${scj.exp_unit}`
                                        : ` ${scj.min_exp_unit ? scj.min_exp_unit : ""} - ${scj.max_exp} ${scj.exp_unit}`
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  {scj.job_type != null ? (
                                    <span className="twm-job-websites site-text-primary">
                                      <i className="ri-building-line"></i>{" "}
                                      {scj.job_type}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>

                                <div className="twm-right-content">
                                  {scj.work_type != null ? (
                                    <div className="twm-jobs-category green">
                                      <span className="twm-bg-purple">
                                        {scj.work_type}
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {/* {scj.minsalary != "" ? (
                                    <div className="twm-jobs-amount">
                                      Rs.{scj.minsalary}-{scj.maxsalary}{" "}
                                      <span>/ {scj.salary_unit}</span>
                                    </div>
                                  ) : (
                                    ""
                                  )} */}
                                  {scj.salary_type == "R" ? (
                                    <div className="twm-jobs-amount">
                                      {scj.jobcur} {scj.minsalary}-
                                      {scj.maxsalary}{" "}
                                      <span>/ {scj.salary_unit}</span>
                                    </div>
                                  ) : scj.salary_type == "F" ? (
                                    <div className="twm-jobs-amount">
                                      {scj.jobcur} {scj.minsalary}
                                      <span>/ {scj.salary_unit}</span>
                                    </div>
                                  ) : scj.salary_type == "N" ? (
                                    <div className="twm-jobs-amount">
                                      <span> Negotiable</span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <Link
                                    to={`/jobs/${scj.slug}`}
                                    className="twm-jobs-browse site-text-primary"
                                  >
                                    Browse Job
                                  </Link>
                                </div>
                              </div>
                            </li>
                          ))
                        : ""}
                    </ul>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-12 rightSidebar">
            <h4 className="twm-s-title mt-0 text-center">Similar Jobs</h4>
            <div className="row">
              {similarjobs.length > 0
                ? similarjobs.map((sj) => (
                    <div
                      className="col-lg-12 col-md-12 m-b30"
                      key={generateRandomString(8)}
                    >
                      <JobItem job={sj} />
                      {/* <div className="twm-jobs-grid-style1">
                        <div className="twm-media">
                          <a href="job-detail_v2.html">
                            <img src={sj.imgUrl} alt={sj.job_title} />
                          </a>
                        </div>
                        <span className="twm-job-post-duration">
                          10 Hours ago
                        </span>
                        <div className="twm-jobs-category">
                          <span className="twm-bg-purple">{sj.work_type}</span>
                        </div>
                        <div className="twm-mid-content">
                          <Link to={`/jobs/${sj.id}`} className="twm-job-title">
                            <h4>{sj.job_title}</h4>
                          </Link>
                          <p className="twm-job-address">
                            <i className="ri-map-pin-line"></i>
                            {sj.job_location}
                          </p>
                          <span className="twm-jobs-type site-text-primary">
                            <i className="ri-briefcase-line"></i> {sj.min_exp}-
                            {sj.max_exp} Year
                          </span>
                          <span className="twm-job-websites site-text-primary">
                            <i className="ri-building-line"></i> {sj.job_type}
                          </span>
                        </div>
                        <div className="twm-right-content">
                          <div className="twm-jobs-amount">
                            Rs.{sj.minsalary}-{sj.maxsalary}{" "}
                            <span>/ {sj.salary_unit}</span>
                          </div>
                          <Link
                            to={`/jobs/${sj.id}`}
                            className="twm-jobs-browse site-text-primary"
                          >
                            Browse Job
                          </Link>
                        </div>
                      </div> */}
                    </div>
                  ))
                : ""}

              <div className="clearfix"></div>
            </div>
            <div className="twm-advertisment">
              <div className="overlay"></div>
              <h4 className="twm-title">Recruiting?</h4>
              <p>
                Get Best Matched Jobs On your Email. <br />
                Add Resume NOW !{" "}
              </p>
              <Link to="/" className="site-button white">
                Read More
              </Link>
            </div>
            <div className="bigyapan">
              <Link to="/">
                <figure>
                  <img src="portal/images/interniship.png" alt="#" />
                </figure>
              </Link>
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>

      <EmailApplyModal jobid={jobsDetail.id} />
    </div>
  );
}
